import * as React from 'react'
import { createForm, Button, Typography } from '@lacedltd/laced-components'
import * as z from 'helpers/zod'
import { withTranslations } from 'helpers'
import { useQueryParams, usePatchWebhookService, useTranslation } from 'hooks'
import { PageTemplate } from '../../shared'
import Hint from '../../Hint'
import * as S from './CancelOrder.styles'

const schema = z.object({
  cancellationReason: z.string().optional()
})

const Form = createForm(schema)

const CancelOrder = () => {
  const { t } = useTranslation()
  const { loading, data, patchWebhookService } = usePatchWebhookService()
  const { name, size, price, image, groupType, token } = useQueryParams([
    'name',
    'price',
    'size',
    'image',
    'groupType',
    'token'
  ])

  const methods = Form.useForm({
    defaultValues: {
      cancellationReason: ''
    }
  })

  const cancellationReasons = t('shared.seller_cancellation_reasons', {
    returnObjects: true
  })

  const conversion = t(`shared.conversion.${groupType}`)

  return (
    <PageTemplate wide heading={t('react_components.cancel_sale.title')}>
      <S.CancelOrderContainer>
        {data?.success ? (
          <S.SuccessMessage variant="body" color="airJordan.p">
            <span
              dangerouslySetInnerHTML={{
                __html: t('react_components.cancel_sale.success_message')
              }}
            ></span>
          </S.SuccessMessage>
        ) : (
          <>
            <S.CancelProductOverview>
              <img src={image} alt={name} />
              <S.CancelProductInfo>
                <Typography.Text variant="body" as="p" color="airJordan.p">
                  {name}
                </Typography.Text>
                <Typography.Text variant="body">{price}</Typography.Text>
                <Typography.Text variant="body">{size}</Typography.Text>
              </S.CancelProductInfo>
            </S.CancelProductOverview>
            <Form.Container
              methods={methods}
              onSubmit={(data) =>
                patchWebhookService({
                  body: {
                    token,
                    cancel_reason: data.cancellationReason
                  }
                })
              }
            >
              <Form.SelectInput
                name="cancellationReason"
                label={t('react_components.cancel_sale.reason')}
                values={Object.entries(cancellationReasons).map(
                  ([value, label]) => {
                    const override_label = t(
                      `shared.seller_cancellation_reasons.${value}`,
                      { conversion }
                    )

                    return {
                      label: override_label,
                      value
                    }
                  }
                )}
              />

              <S.ConfirmMessage variant="body" as="p">
                {t('react_components.cancel_sale.confirm_message')}
              </S.ConfirmMessage>

              <Button variant="primary" loading={loading}>
                {t('react_components.cancel_sale.confirm')}
              </Button>

              {data?.message && <Hint type="error" text={data.message} />}

              <Typography.Text variant="footnote">
                {t('react_components.cancel_sale.warning')}
              </Typography.Text>
            </Form.Container>
          </>
        )}
      </S.CancelOrderContainer>
    </PageTemplate>
  )
}

export default withTranslations(CancelOrder)
